import type { Biller } from '@/types/portal';

/**
 * Paybill accounts a bill payment can settle to. The favourites ship pinned so
 * the Pay a Bill screen opens with the billers this agency pays most often.
 */
export const billers: Biller[] = [
  {
    id: 'biller-kplc-prepaid',
    name: 'KPLC Prepaid',
    mark: 'KP',
    paybill: '888880',
    category: 'Electricity',
    favourite: true,
  },
  {
    id: 'biller-kplc-postpaid',
    name: 'KPLC Postpaid',
    mark: 'KL',
    paybill: '888888',
    category: 'Electricity',
    favourite: true,
  },
  {
    id: 'biller-nairobi-water',
    name: 'Nairobi Water',
    mark: 'NW',
    paybill: '444700',
    category: 'Water',
    favourite: true,
  },
  {
    id: 'biller-dstv',
    name: 'DStv Kenya',
    mark: 'DS',
    paybill: '444900',
    category: 'Pay TV',
    favourite: true,
  },
  {
    id: 'biller-gotv',
    name: 'GOtv Kenya',
    mark: 'GT',
    paybill: '423655',
    category: 'Pay TV',
    favourite: false,
  },
  {
    id: 'biller-safaricom-fibre',
    name: 'Safaricom Home Fibre',
    mark: 'SF',
    paybill: '850200',
    category: 'Internet',
    favourite: false,
  },
  {
    id: 'biller-zuku',
    name: 'Zuku Internet',
    mark: 'ZK',
    paybill: '500500',
    category: 'Internet',
    favourite: false,
  },
  {
    id: 'biller-safaricom-postpaid',
    name: 'Safaricom Postpaid',
    mark: 'SP',
    paybill: '333333',
    category: 'Telecom',
    favourite: false,
  },
  {
    id: 'biller-jambopay',
    name: 'JamboPay Services',
    mark: 'JP',
    paybill: '502020',
    category: 'Government',
    favourite: false,
  },
];